module.exports = __webpack_public_path__ + "static/Jonny-2ad14ff40fbd9b0e2086d43f41725564.jpg";